/** @jsxRuntime classic */
/** @jsx jsx */

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { css, jsx } from '@emotion/react';
import Plans from '../user/Plans';

export default function TrialEnded() {
  const { t } = useTranslation();

  return (
    <Box
      css={css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 2rem auto;
        padding: 2rem;
        text-align: center;
      `}
    >
      <Typography variant="h4" gutterBottom>
        {t('Ditt provkonto har löpt ut')}
      </Typography>

      <Typography variant="body1" paragraph>
        {t(
          'Tack för att du provat Klang.ai! Din provperiod har nu löpt ut. För att fortsätta använda tjänsten behöver du uppgradera till ett betalande konto.'
        )}
      </Typography>

      <Plans showEnterprise />
    </Box>
  );
}
